export const colors = [
    '#0f4c5cff',
    '#f6bd60ff',
    '#84a59dff',
    '#e5989bff',
    '#e9c46aff',
    '#e07a5fff',
    '#1c2541ff',
    '#772e25ff',
    '#606c38ff',
    '#118ab2ff',
    '#247ba0ff',
    '#f28f3bff',
    '#e76f51ff',
    '#e09f3eff',
    '#9e2a2bff',
    '#f28f3bff',
    '#ef6351ff',
    '#1b998bff',
    '#52489cff',
    '#8d0801ff'
]